module.exports = __webpack_public_path__ + "static/owlbear-935a15f9e2c49ab71a9f580acf3e0e92.jpeg";